const customQuantity = (quantity: HTMLElement) => {
  const parentForm = quantity.closest('form') as HTMLFormElement;
  const quantityInput = parentForm.querySelector('input[name="quantity"]') as HTMLInputElement;
  const min = quantityInput.getAttribute('min');
  let max = quantityInput.getAttribute('max');
  if (max == '' || max == null) {
    max = String(100000);
  }
  const variationsSelects = parentForm.querySelector('.variations select') as HTMLFormElement;

  // Quanity add and min
  const plus = quantity.querySelector('.uitjes-quantity__plus') as HTMLElement;
  const minus = quantity.querySelector('.uitjes-quantity__minus') as HTMLElement;
  const value = quantity.querySelector('.uitjes-quantity__value') as HTMLElement;
  value.innerHTML = min;

  if (min === max) {
    plus.classList.add('uitjes-quantity__control--disabled');
    minus.classList.add('uitjes-quantity__control--disabled');
  }

  // Functions
  const updateValue = (min, max, option) => {
    const newValue = quantity.querySelector('.uitjes-quantity__value') as HTMLElement;
    const valueNum = Number(newValue.innerHTML);

    if (option === 'plus' && valueNum < Number(max)) {
      newValue.innerHTML = String(valueNum + 1);
      quantityInput.value = String(valueNum + 1);

      // Trigger input change
      quantityInput.dispatchEvent(new Event('change'));

      if ((valueNum + 1) === Number(max)) {
        plus.classList.add('uitjes-quantity__control--disabled');
      } else {
        plus.classList.remove('uitjes-quantity__control--disabled');
        minus.classList.remove('uitjes-quantity__control--disabled');
      }
    } else if (option === 'minus' && valueNum > Number(min)) {
      newValue.innerHTML = String(valueNum - 1);
      quantityInput.value = String(valueNum - 1);

      // Trigger input change
      quantityInput.dispatchEvent(new Event('change'));

      if ((valueNum - 1) === Number(min)) {
        minus.classList.add('uitjes-quantity__control--disabled');
      } else {
        minus.classList.remove('uitjes-quantity__control--disabled');
        plus.classList.remove('uitjes-quantity__control--disabled');
      }
    }
  };

  if (variationsSelects) {
    variationsSelects.addEventListener('change', () => {
      const parentForm = quantity.closest('form') as HTMLFormElement;
      const quantityInput = parentForm.querySelector('input[name="quantity"]') as HTMLInputElement;
      const min = quantityInput.getAttribute('min');
      const max = quantityInput.getAttribute('max');
      quantityInput.value = min;
      value.innerHTML = min;

      if (min === max) {
        plus.classList.add('uitjes-quantity__control--disabled');
        minus.classList.add('uitjes-quantity__control--disabled');
      } else {
        plus.classList.remove('uitjes-quantity__control--disabled');
        minus.classList.add('uitjes-quantity__control--disabled');
      }

      setTimeout(() => {
        const height = document.getElementById('primary').clientHeight;

        // Send the height to the parent window
        parent.postMessage({
          type: 'iframe_height',
          value: height,
        }, '*');
      }, 300);
    });
  }

  plus.addEventListener('click', () => {
    const parentForm = quantity.closest('form') as HTMLFormElement;
    const quantityInput = parentForm.querySelector('input[name="quantity"]') as HTMLInputElement;
    const min = quantityInput.getAttribute('min');
    let max = quantityInput.getAttribute('max');
    if (max == '' || max == null) {
      max = String(100000);
    }
    updateValue(min, max, 'plus');
  });

  minus.addEventListener('click', () => {
    const parentForm = quantity.closest('form') as HTMLFormElement;
    const quantityInput = parentForm.querySelector('input[name="quantity"]') as HTMLInputElement;
    const min = quantityInput.getAttribute('min');
    let max = quantityInput.getAttribute('max');
    if (max == '' || max == null) {
      max = String(100000);
    }
    updateValue(min, max, 'minus');
  });
};

export default customQuantity;
